import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "ticketPrice",
    "ticketCount",
    "grossRevenue",
    "platformFee",
    "transactionFee",
    "netRevenue",
    "displayPrice",
    "priceLabel",
    "feePayerValue",
    "buyerPaysRadio",
    "organizerPaysRadio"
  ]

  static values = {
    feePercentage: Number,
    platformFeePerTicket: Number,
    transactionFeePercentage: Number,
    transactionFeeFixed: Number,
    buyerPaysLabel: String,
    organizerPaysLabel: String,
    basePriceLabel: String,
    buyerPaysTicketLabel: String
  }

  connect() {
    this.updateCalculator()
  }

  updateCalculator() {
    const basePrice = parseFloat(this.ticketPriceTarget.value) || 0
    const count = parseInt(this.ticketCountTarget.value) || 0
    const buyerPaysFees = this.buyerPaysRadioTarget.checked

    let actualTicketPrice, gross, platformFeeTotal, transactionFeeTotal, totalFees, net

    if (buyerPaysFees) {
      // Buyer pays fees - organizer gets the full ticket price, buyer pays additional fees
      actualTicketPrice = basePrice
      gross = actualTicketPrice * count
      platformFeeTotal = (gross * (this.feePercentageValue / 100)) + (count * this.platformFeePerTicketValue)
      transactionFeeTotal = (gross * (this.transactionFeePercentageValue / 100)) + (count * this.transactionFeeFixedValue)
      totalFees = platformFeeTotal + transactionFeeTotal
      net = gross // Organizer keeps full gross revenue when buyer pays fees

      this.priceLabelTarget.textContent = this.basePriceLabelValue
      this.feePayerValueTarget.textContent = this.buyerPaysLabelValue
      this.feePayerValueTarget.style.color = '#10b981' // Green
    } else {
      // Organizer pays fees - fees are deducted from what organizer receives
      actualTicketPrice = basePrice
      gross = actualTicketPrice * count
      platformFeeTotal = (gross * (this.feePercentageValue / 100)) + (count * this.platformFeePerTicketValue)
      transactionFeeTotal = (gross * (this.transactionFeePercentageValue / 100)) + (count * this.transactionFeeFixedValue)
      totalFees = platformFeeTotal + transactionFeeTotal
      net = gross - totalFees // Organizer pays fees from their revenue

      this.priceLabelTarget.textContent = this.buyerPaysTicketLabelValue
      this.feePayerValueTarget.textContent = this.organizerPaysLabelValue
      this.feePayerValueTarget.style.color = '#f59e0b' // Orange
    }

    this.displayPriceTarget.textContent = `$${this.formatCurrency(actualTicketPrice)}`
    this.grossRevenueTarget.textContent = `$${this.formatCurrency(gross)}`
    this.platformFeeTarget.textContent = `$${this.formatCurrency(platformFeeTotal)}`
    this.transactionFeeTarget.textContent = `$${this.formatCurrency(transactionFeeTotal)}`
    this.netRevenueTarget.textContent = `$${this.formatCurrency(net)}`
  }

  formatCurrency(amount) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
